<template>
  <div class="unauthorized-container">
    <div class="unauthorized-content">
      <div class="error-icon">
        <i class="fas fa-shield-alt"></i>
      </div>
      <h1 class="error-title">Acesso Não Autorizado</h1>
      <p class="error-message">
        As credenciais de API fornecidas são inválidas ou não foram configuradas corretamente.
      </p>
      <p class="error-details">
        Por favor, entre em contato com o administrador do sistema para verificar as configurações de integração.
      </p>
      <div class="error-code" v-if="errorCode">
        <span class="code-label">Código do Erro:</span>
        <span class="code-value">{{ formatErrorCode(errorCode) }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Unauthorized',
  props: {
    errorCode: {
      type: String,
      default: null
    }
  },
  methods: {
    formatErrorCode(code) {
      const codes = {
        '401': '401 - Não Autorizado',
        '403': '403 - Acesso Negado',
        'NO_CREDENTIALS': 'Credenciais não configuradas',
        'INVALID_CREDENTIALS': 'Credenciais inválidas',
        'INVALID_SESSION': 'Sessão inválida ou expirada'
      };
      return codes[code] || code;
    }
  }
}
</script>

<style scoped>
.unauthorized-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: linear-gradient(165deg, #061318 0%, #0E2A32 42%, #124E57 100%);
  padding: 20px;
}

.unauthorized-content {
  background: #ffffff;
  border-radius: 16px;
  padding: 48px;
  max-width: 500px;
  width: 100%;
  text-align: center;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.35);
}

.error-icon {
  font-size: 80px;
  color: #ef4444;
  margin-bottom: 24px;
}

.error-icon i {
  display: block;
}

.error-title {
  font-size: 28px;
  font-weight: 700;
  color: #1f2937;
  margin-bottom: 16px;
}

.error-message {
  font-size: 16px;
  color: #4b5563;
  margin-bottom: 12px;
  line-height: 1.6;
}

.error-details {
  font-size: 14px;
  color: #6b7280;
  margin-bottom: 24px;
  line-height: 1.6;
}

.error-code {
  margin-top: 24px;
  padding: 12px;
  background: #f3f4f6;
  border-radius: 8px;
  border-left: 4px solid #ef4444;
}

.code-label {
  font-size: 12px;
  color: #6b7280;
  display: block;
  margin-bottom: 4px;
}

.code-value {
  font-size: 14px;
  font-weight: 600;
  color: #1f2937;
  font-family: 'Courier New', monospace;
}
</style>
